
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.834 7.691a7.483 7.483 0 011.579-2.716.444.444 0 01.477-.119l1.7.605a.888.888 0 001.169-.672l.325-1.77a.443.443 0 01.342-.353 7.59 7.59 0 013.15 0c.175.038.31.177.343.353l.325 1.77a.885.885 0 001.168.672l1.7-.605a.444.444 0 01.478.12 7.486 7.486 0 011.578 2.715.44.44 0 01-.136.473l-1.377 1.164a.879.879 0 000 1.345l1.377 1.163a.44.44 0 01.136.473 7.482 7.482 0 01-1.578 2.716.444.444 0 01-.477.119l-1.7-.605a.886.886 0 00-1.17.672l-.324 1.77a.441.441 0 01-.344.353c-1.038.22-2.11.22-3.149 0a.443.443 0 01-.343-.353l-.324-1.77a.885.885 0 00-1.169-.672l-1.7.605a.444.444 0 01-.477-.119 7.483 7.483 0 01-1.578-2.716.44.44 0 01.135-.473l1.378-1.163a.88.88 0 000-1.345L2.97 8.164a.44.44 0 01-.135-.473h-.001zm4.979 2.31A2.188 2.188 0 1012.188 10a2.188 2.188 0 00-4.375 0z"}})])
          )
        }
      }
    